import { AuthApi } from "@/api/auth";
import { SetPasswordRequest } from "@/api/auth/types";
import { ROUTE } from "@/utils";
import { useMutation } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { useNavigate } from "react-router-dom";

export const useSetAdminPassword = () => {
  const notify = useNotify();
  const navigate = useNavigate();

  const { mutate: setAdminPassword, isPending: isSetAdminPasswordLoading } =
    useMutation({
      mutationFn: (body: SetPasswordRequest) => AuthApi.setPassword(body),
      onSuccess: () => {
        notify("Password has been set!");
        navigate(ROUTE.AUTH_LOGIN);
      },
      onError: (error) => {
        notify(error, { type: "error" });
      },
    });

  return { setAdminPassword, isSetAdminPasswordLoading };
};
